import React, { useEffect } from "react";

import { Grid } from "@mui/material";
import AppDialog from "../../components/Common/AppDialog";
import CheckBox from "../../components/Form/CheckBox";
import CustomAutocomplete from "../../components/Form/CustomAutocomplete";
import CustomTextField from "../../components/Form/CustomTextField";
import '../Orders/order.css';
import Helpers from "../../helpers/helpers";

const AddAddress = ({ open, close, type, country, setFormValues, formValues, handleSubmitAddress, selectedAddressID, error, creatable, editable }) => {
    useEffect(() => {
        if (type === "Edit") {
            setFormValues(formValues);
        } else {
            setFormValues("")
        }
    }, []);

    return (
        <AppDialog
            open={open}
            close={() => (close())}
            titleIcon={type === "Add" ? "add" : "edit"}
            title={`${type} address`}
            negativeTitle={'Cancel'}
            negativePress={() => (close())}
            positivePress={() => handleSubmitAddress(type, selectedAddressID)}
            positiveTitle={type === 'Add' ? 'Save' : 'Save Changes'}
            width={'60%'}
        >
            <Grid container spacing={2} mt={1}>
                <Grid item sm={12} md={12}>
                    <CustomTextField
                        title={'Full name'}
                        values={formValues?.name}
                        placeholder={'Recipient name'}
                        error={error && !formValues?.name && "The name field is required."}
                        subtitle={'Complete name of the person receiving the order'}
                        onChange={(e) => setFormValues((prevValues) => ({
                            ...prevValues,
                            name: e
                        }))}
                    />
                </Grid>
                <Grid item sm={12} md={6}>
                    <CustomTextField
                        title={'Phone number'}
                        values={formValues?.phone}
                        error={error && !formValues?.phone ? "The phone field is required." : error && !Helpers.phoneLengthValidation(formValues?.phone) && "The phone is invalid"}
                        placeholder={'65123456789'}
                        type={'phone'}
                        onChange={(e) => setFormValues((prevValues) => ({
                            ...prevValues,
                            phone: e
                        }))}
                    />
                </Grid>
                <Grid item sm={12} md={6}>
                    <CustomTextField
                        title={'Company name (optional)'}
                        values={formValues?.company}
                        placeholder={'Company name'}
                        onChange={(e) => setFormValues((prevValues) => ({
                            ...prevValues,
                            company: e
                        }))}
                    />
                </Grid>
                <Grid item sm={12} md={12}>
                    <CustomTextField
                        title={'Address line 1'}
                        values={formValues?.address_line_1}
                        error={error && !formValues?.address_line_1 && "The address line 1 field is required."}
                        placeholder={'House number, block number, street name'}
                        onChange={(e) => setFormValues((prevValues) => ({
                            ...prevValues,
                            address_line_1: e
                        }))}
                    />
                </Grid>
                <Grid item sm={12} md={12}>
                    <CustomTextField
                        title={'Address line 2 (Optional)'}
                        values={formValues?.address_line_2}
                        placeholder={'Apartment, building name'}
                        onChange={(e) => setFormValues((prevValues) => ({
                            ...prevValues,
                            address_line_2: e
                        }))}
                    />
                </Grid>
                <Grid item sm={12} md={6}>
                    <CustomAutocomplete
                        title={'Country'}
                        error={error && !formValues?.country_id && "The country field is required."}
                        values={formValues?.country_id}
                        data={country}
                        placeholder={'Please select'}
                        onChange={(e, value) => setFormValues((prevValues) => ({
                            ...prevValues,
                            country_id: value?.id
                        }))}
                        valueName={"id"}
                        labelName={"name"}
                    />
                </Grid>
                <Grid item sm={12} md={6}>
                    <CustomTextField
                        title={'City'}
                        values={formValues?.city}
                        error={error && !formValues?.city && "The city field is required."}
                        placeholder={'City'}
                        onChange={(e) => setFormValues((prevValues) => ({
                            ...prevValues,
                            city: e
                        }))}
                    />
                </Grid>
                <Grid item sm={12} md={6}>
                    <CustomTextField
                        title={'State / Province / Region (optional)'}
                        values={formValues?.state}
                        placeholder={'State / Province / Region'}
                        onChange={(e) => setFormValues((prevValues) => ({
                            ...prevValues,
                            state: e
                        }))}
                    />
                </Grid>
                <Grid item sm={12} md={6}>
                    <CustomTextField
                        title={'Postal code'}
                        type={'phone'}
                        values={formValues?.postal_code}
                        error={error && !formValues?.postal_code && "The postal code field is required."}
                        placeholder={'6-digit postal code'}
                        onChange={(e) => setFormValues((prevValues) => ({
                            ...prevValues,
                            postal_code: e
                        }))}
                    />
                </Grid>
                <Grid item sm={12} md={6}>
                    <CheckBox
                        label={'Set as default shipping address'}
                        values={formValues?.default_shipping_address === 1 ? true : false}
                        onChange={(event) => setFormValues((prevValues) => ({
                            ...prevValues,
                            default_shipping_address: event.target.checked ? 1 : 0
                        }))}
                    />
                </Grid>
            </Grid>

        </AppDialog>
    )
}

export default AddAddress;